// extracted by mini-css-extract-plugin
var _1 = "Breadcrumbs-module__animateUploadProgressBarWidth--TJczI";
var _2 = "Breadcrumbs-module__animatedBackground--PhAA5";
var _3 = "Breadcrumbs-module__container--XzG0x";
var _4 = "Breadcrumbs-module__small--vFeal";
var _5 = "Breadcrumbs-module__truncate--ZBRti";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "small", _5 as "truncate" }
